<template>
<div>
  <v-card class="md-layout-item card">
    <v-tabs
      v-model="tab"
      grow           
      centered            
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        Invoice Payment        
      </v-tab>

      <v-tab href="#tab-2">
        Transaction History      
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        key="tab-1"
        value="tab-1"
      >
        <v-card flat class="card">          
          <div style="align-content: space-between;display: flex;">
            <v-autocomplete key="supplier" v-model="inout" :items="inouts" @change="paymentValueChanged()" placeholder="In/Out"></v-autocomplete>
            <v-autocomplete key="supplierm" v-model="method" :items="methods" @change="paymentValueChanged()" placeholder="Trans Methods"></v-autocomplete>
          </div>
          <div style="align-content: space-between;display: flex;">
            <v-text-field v-model="description" @change="paymentValueChanged()" label="Descriptions"> </v-text-field>
            <v-text-field v-model="amount" @change="paymentValueChanged()" label="Amount"> </v-text-field>
          </div>
        </v-card>
      </v-tab-item>

        <v-tab-item
        key="tab-2"
        value="tab-2"
      >
        <v-card flat>        
         <ag-grid-vue style="width: 100%;"
                 class="ag-theme-balham"
                 domLayout="autoHeight"
                 :columnDefs="columnDefs"
                 :enableFillHandle="true"
                 :context="context"
                 :rowData="payments">
                </ag-grid-vue>          
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'  
  import { mapState, mapActions } from 'vuex'
  import {AgGridVue} from "ag-grid-vue";

  var crOrDbValueGetter = function (param) {
    let data = param.data;
    return data.amountCredit>0?"CR":"DB"
  };

  var amountValueGetter = function (param) {
    let data = param.data;
    return data.amountCredit>0?data.amountCredit:data.amountDebit
  };

  var methodValueGetter = function (param) {
    let data = param.data;
    if (data.accountTransaction.cash>0) {
          return "CASH"
        }
        else if (data.accountTransaction.cheque>0) {
          return "CHEQUE"
        }
        else if (data.accountTransaction.bankDeposit>0) {
          return "BANK DEPOSIT"
        }
        else if (data.accountTransaction.card>0) {
          return "CARD"
        }
        return ""
  };

  export default {
    name: 'payment-detail-panel',
    computed: {
        ...mapState('invoice', ['selectedInvoice','paymentData']),
    },
    mixins: [validationMixin],
    data: () => ({
      method: null,
      tab: null,
      methods: ['Cash', 'Cheque','Bank','Card'],
      inout: null,
      inouts: ['In', 'Out'],
      description:null,
      amount: null,
      payments:[],
      columnDefs:[
          { headerName: 'Rec No', field:'accountTransactionId',width:75},
          { headerName: 'Date', field:'createdAt',width:75},
          { headerName: 'CR or DB', valueGetter: crOrDbValueGetter,width:80},
          { headerName: 'Method', valueGetter:methodValueGetter,width:75},
          { headerName: 'amount', valueGetter:amountValueGetter,width:75},
        ], 
    }),
    components: {
            AgGridVue,            
    },
    beforeMount() {
        this.context = { componentParent: this };
    },
    created () {
      // let self = this
    },
     watch: {
        selectedInvoice(newValue, oldValue) {      
            console.log(oldValue)      
            this.inout = null;
          this.method = null;
          this.amount = null;
          this.description = null;    
            if (newValue.invoicePayments) {
              this.payments = JSON.parse(JSON.stringify(newValue.invoicePayments))
            }
            else {
             this.payments=[] 
            }
        },
        paymentData(newValue, oldValue) {      
          console.log(oldValue)            
          console.log(newValue)            
          this.inout = null;
          this.method = null;
          this.amount = null;
          this.description = null;  
        }      
    },
    methods: {
      ...mapActions('invoice', ['updatePayment']),
          
      paymentValueChanged() {
        this.updatePayment({inout:this.inout, method:this.method, description:this.description, amount:parseFloat(this.amount)})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card {    
    margin-left:10px
  }

  .v-container {
    padding-top: 0px;
    padding-bottom: 0px !important;
    padding-right:0px;
    padding-left:0px
  }
  
  .v-text-field {     
    margin-right:10px;    
    margin-bottom:-4px;
    margin-top:-4px;
  }
  .action-box {         
   margin-top: 2px;
  }

  .v-text-field.md-focused label, .v-text-field.md-has-value label {
    top:5px;
  }
  
</style>